import { useTranslation } from "react-i18next";
import SliderInsp from "../../../components/helper/sliderInsp";
export default function Inspiration(props) {
  const { t } = useTranslation("common");
  const s = "main.";
  return (
    <div className={"container md:px-0 px-4"}>
      <div className={"text-center"}>
        <h2 className={"font-bold text-[28px] "}>
          {" "}
          {t("frontpage.custom_link_title")}
        </h2>
      </div>
      <div className={"mt-10 dot-to-b"}>
        <SliderInsp data={props.data.data} />
      </div>
    </div>
  );
}
